<!--
Author: Liubo
Date: 2018-09-17
Desc: 轮播广告-中型
 -->
<template>
    <div :class="'bizcomp-ad bizcomp ' + className">
        <comp-title :title="title">
            <p style="line-height:34px;margin-right:10px;">
                自定义内容
            </p>
        </comp-title>
        <el-carousel :interval="5000" :height="height + 'px'" :type="type">
            <el-carousel-item v-for="item in data" :key="item.fileid">
                <div class="login-ad">
                    <a v-if="item.linkurl" :href="item.linkurl" :target="item.opentype==='2'?'_blank':'_self'">
                        <img :src="$util.src('/common/download', { id: item.fileid })" :style="'width:100%;height:' + height + 'px;'"></a>
                    <img v-if="!item.linkurl" :src="$util.src('/common/download', { id: item.fileid })" :style="'width:100%;height:' + height + 'px;'">
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "Carousel",
    mixins: [mixin],
    data () {
        return {
            type: "",
            data: [],
            height: 300
        };
    },
    mounted () {
    }
};
</script>
